import { AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

export const MainErrorFallback = ({ error }: { error: Error }) => {
  const { t } = useTranslation();
  console.error(error);

  return (
    <div className='flex min-h-screen items-center justify-center p-4'>
      <Alert variant='destructive' className='max-w-[600px]'>
        <AlertCircle className='h-4 w-4' />
        <AlertTitle>{t('common.errors.somethingWentWrong')}</AlertTitle>
        <AlertDescription className='break-words'>{error?.message}</AlertDescription>
      </Alert>
    </div>
  );
};

export default MainErrorFallback;
